module.exports = __webpack_public_path__ + "static/media/wix.00a6f03d.png";